export const SWAP_TAB_OMIT_KEYS = [
  "asset_name",
  "total_amount",
  "miner_fee_asset_name",
  "estimated_miner_fee",
  "prepared_miner_fee",
  "last_estimated_miner_fee_date",
];

export const NON_SWAP_TAB_OMIT_KEYS = [
  "max_slippage",
  "swap_execution_type",
  "currency_from",
  "currency_to",
  "total_amount_from",
  "total_amount_to",
];
